import { FilterBase } from "@models/base/filterBase.model"

export class ExpedienteFilter extends FilterBase {
  public caratula: string | null = null;
  public identificadorUnico: string | null = null;
  public numero: string | null = null;
  public idsEstadoExpediente: number[] | null = null;
  public idsJuzgados: number[] | null = null;
  public idsTipoPrioridad: number[] | null = null;
  public idsTipoExpediente: number[] | null = null;
  public idsTipoGrupoExpediente: number[] | null = null;
  public idsPersona: number[] | null = null;
  public activo: boolean | null = null;
  public sinClave: boolean | null = null;
  public fechaAltaDesde: Date | null = null;
  public fechaAltaHasta: Date | null = null;
  public fechaModificacionDesde: Date | null = null;
  public fechaModificacionHasta: Date | null = null;
  public creadoPor: number[] | null = null;
  public modificadoPor: number[] | null = null;
  public autorizadoPor: number[] | null = null;
}
